import { useState } from "react";

import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

interface IRemoveFromNylasButtonProperties {
  removeNylasFromUser: () => Promise<void>;
}

const RemoveFromNylasButton = ({ removeNylasFromUser }: IRemoveFromNylasButtonProperties) => {
  const [isRemovingNylasFromUser, setIsRemovingNylasFromUser] = useState(false);

  const handleRemoveNylasFromUser = async () => {
    setIsRemovingNylasFromUser(true);
    await removeNylasFromUser();
    setIsRemovingNylasFromUser(false);
  };

  return (
    <Button color="error" disabled={isRemovingNylasFromUser} onClick={handleRemoveNylasFromUser} variant="contained">
      {isRemovingNylasFromUser ? (
        <>
          Removing Connected Account
          <CircularProgress
            size={20}
            sx={{
              color: "white",
              ml: 2,
            }}
          />
        </>
      ) : (
        "Remove Connected Account"
      )}
    </Button>
  );
};

export default RemoveFromNylasButton;
